import { api } from "#app/http/api";
import { SimilarPartFeedbackDto } from "#modules/feedback/infra/fetchSimilarPartFeedbacks.api";
import { ApiError } from "#shared/infra/apiError";
import { SimilarPartFeedbackRating } from "shared";

export const updateSimilarPartFeedback = async ({
  feedbackId,
  rating,
  index,
}: {
  feedbackId: string;
  rating: SimilarPartFeedbackRating;
  index: number;
}): Promise<SimilarPartFeedbackDto> => {
  const response = await api.feedback.updateSimilarPartFeedback.mutation({
    params: { feedbackId },
    body: { rating, index },
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update SimilarPartFeedback", response.status, response.body);
};
